import { render, staticRenderFns } from "./uploadFile.vue?vue&type=template&id=6ec95a6b&scoped=true"
import script from "./uploadFile.vue?vue&type=script&lang=js"
export * from "./uploadFile.vue?vue&type=script&lang=js"
import style0 from "./uploadFile.vue?vue&type=style&index=0&id=6ec95a6b&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ec95a6b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6ec95a6b')) {
      api.createRecord('6ec95a6b', component.options)
    } else {
      api.reload('6ec95a6b', component.options)
    }
    module.hot.accept("./uploadFile.vue?vue&type=template&id=6ec95a6b&scoped=true", function () {
      api.rerender('6ec95a6b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Upload/uploadFile.vue"
export default component.exports